import styled from 'styled-components'

import { MAX_UPLOAD_SIZE } from './upload-constants'

const Container = styled.div`
  font-family: NeueHaasUnica, sans-serif;
  font-size: 18px;
  margin: 20px 0;
`

const AutoBreak = styled.div`
  padding: 0;
  margin: 0;
  display: none;
  @media(max-width: 468px){
    display: block;
  }
`

const TitleLabel = styled.span<{ disabled: boolean }>`
  color: ${(props) => (props.disabled ? '#cccccc' : '#333333')};
`
const NumberLabel = styled.span<{ disabled: boolean }>`
  color: ${() => '#003557'};
  font-weight: bold;
`

type SpaceAvailableProps = {
  space: number
  disableField: boolean
}

const SpaceAvailable = ({ space, disableField }: SpaceAvailableProps) => (
  <Container>
    <TitleLabel disabled={disableField}>Photo/Document Space Available: </TitleLabel>&nbsp;
    <NumberLabel disabled={disableField}>
      <AutoBreak />{((MAX_UPLOAD_SIZE - space) / 1000 / 1000).toFixed(3)} MB
    </NumberLabel>
    <br />
    <TitleLabel disabled={disableField}>Video Space Available: </TitleLabel>&nbsp;
    <AutoBreak />
    <NumberLabel disabled={disableField}>Unlimited</NumberLabel>
    <TitleLabel disabled={disableField}>
      <i>
        <small> (upload time may vary depending on file size)</small>
      </i>
    </TitleLabel>
    &nbsp;
  </Container>
)

export { SpaceAvailable }
